import { useEffect } from "react";
import useSWR from "swr";
import {
  registerChannelStates,
  type ChannelStateDef,
} from "@/components/badge/channel-state";

// Runtime channel-state catalog (channel_state table; created from the
// Channel flow editor, admin-gated). Mounted once in the authed shell so the
// registry fills early; the flow editor also calls it to re-render when the
// catalog arrives or changes.
export const useChannelStates = (
  enabled = true
): ChannelStateDef[] | undefined => {
  const { data } = useSWR<ChannelStateDef[]>(
    enabled ? ["/channel-states"] : null
  );
  useEffect(() => {
    if (data) registerChannelStates(data);
  }, [data]);
  return data;
};
